<template>
  <!-- 这是添加用户区域 -->
  <div class="centerUser">
    <el-container>
      <el-header>
        <!-- <h2>{{$t('message.用户中心')}}</h2> -->
      </el-header>
      <el-main>
        <el-tabs v-model="action" style="margin-bottom: 40px">
          <el-tab-pane :label="$t('message.个人信息')" name="0"></el-tab-pane>
          <el-tab-pane :label="$t('message.注册电话')" name="1"></el-tab-pane>
          <el-tab-pane :label="$t('message.账号密码')" name="2"></el-tab-pane>
        </el-tabs>
        <div class="container">
          <el-form
            :model="form"
            :rules="rules"
            @submit.native.prevent
            ref="ruleForm0"
            v-if="action == 0"
            labelWidth="80px"
            labelPosition="left"
          >
            <img
              :src="upimg == '' ? defaultimg : '/rs/headimg?headImgId=' + upimg"
              alt=""
              style="max-width: 200px; max-height: 200px; margin-bottom: 20px"
              v-if="imageUrl.length < 1000"
            />
            <!-- <el-popover v-if="imageUrl.length<1000" placement="top-start" title="" trigger="hover">
                  <img :src="imageUrl==''?defaultimg:'/rs/headimg?headImgId=' + imageUrl" alt="" style="max-width: 500px; max-height: 500px">
                  <img slot="reference" :src="imageUrl==''?defaultimg:'/rs/headimg?headImgId=' + imageUrl" style="max-width: 120px; max-height: 30px;">
                </el-popover> -->
            <el-popover
              v-if="imageUrl.length > 1000"
              placement="top-start"
              title=""
              trigger="hover"
              style="max-width: 200px; max-height: 200px; margin-bottom: 20px"
            >
              <img
                :src="imageUrl"
                alt=""
                style="max-width: 300px; max-height: 300px; margin-bottom: 20px"
              />
              <img
                slot="reference"
                :src="imageUrl"
                style="max-width: 200px; max-height: 200px; margin-bottom: 20px"
              />
            </el-popover>
            <el-form-item :label="$t('message.姓名')" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('message.性别')" style="text-align: left">
              <el-radio v-model="form.sex" :label="0">{{
                $t("message.保密")
              }}</el-radio>
              <el-radio v-model="form.sex" :label="1">{{
                $t("message.男")
              }}</el-radio>
              <el-radio v-model="form.sex" :label="2">{{
                $t("message.女")
              }}</el-radio>
            </el-form-item>
            <el-form-item
              :label="$t('message.选择头像')"
              style="text-align: left"
            >
              <div>
                <!-- <img  :src="'/rs/headimg?headImgId=' + img" class="img"/> -->

                <el-input
                  type="file"
                  v-model="edituserinfo.headimg"
                  @change="handlechange"
                  class="fileupload"
                  ref="files"
                />
              </div>
            </el-form-item>
            <el-form-item> </el-form-item>
          </el-form>

          <el-form
            :model="form"
            :rules="rules"
            ref="ruleForm1"
            @submit.native.prevent
            v-if="action == 1"
            labelWidth="80px"
            labelPosition="left"
          >
            <el-form-item :label="$t('message.电话')" prop="tel">
              <div style="display: flex">
                <!-- <el-select :placeholder="$t('message.请选择地区')" filterable v-model="phone_code" clearable @change="selectedPhone">
                <el-option
                  v-for="item in this.countryCode"
                  :key="item.english_name"
                  :label="item.chinese_name+' +'+item.phone_code"
                  :value="item.phone_code">
                </el-option>
                <span></span>
              </el-select> -->
                <el-input
                  v-model="form.tel"
                  :placeholder="$t('message.请输入电话号码')"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item :label="$t('message.验证码')" prop="confirmCode">
              <div style="display: flex">
                <el-input v-model="form.confirmCode" width="200" />
                <el-button @click="getCode" :disabled="codeable" size="mimi">{{
                  $t("message.获取验证码")
                }}</el-button>
              </div>
              <span v-if="time > 1">{{
                time == 60 ? "" : time + $t("message.秒后再次获取验证码")
              }}</span>
            </el-form-item>
            <el-form-item> </el-form-item>
          </el-form>

          <el-form
            :model="pass"
            :rules="rules"
            @submit.native.prevent
            ref="ruleForm2"
            v-if="action == 2"
            labelWidth="80px"
            labelPosition="left"
          >
            <el-form-item :label="this.$t('message.原密码')" prop="oldpass">
              <el-input v-model="pass.oldpass" type="password"></el-input>
            </el-form-item>
            <el-form-item :label="this.$t('message.新密码')" prop="newpass">
              <el-input v-model="pass.newpass" type="password"></el-input>
            </el-form-item>
            <el-form-item :label="this.$t('message.再次输入')" prop="againpass">
              <el-input v-model="pass.againpass" type="password"></el-input>
            </el-form-item>
            <el-form-item> </el-form-item>
          </el-form>
        </div>
      </el-main>
      <el-footer style="text-align: right; line-height: 60px">
        <el-button type="primary" @click="submitFormyes(action)">{{
          $t("message.确认修改")
        }}</el-button>
        <el-button @click="resetForm(action)" type="primary">{{
          $t("message.重置")
        }}</el-button>
        <!-- <el-button type="info" @click="goout">{{$t('message.退出')}}</el-button> -->
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
import countryCode from "@/assets/fronttelphone";
export default {
  name: "userCenter",
  data() {
    return {
      form: {
        loginID: "",
        name: "",
        workname: "",
        tel: "",
        sex: "0",
        confirmCode: "",
      },
      handleID: "",
      countryCode,
      phone_code: "",
      edituserinfo: {
        gender: "",
        name: "",
      },
      time: 60,
      codeable: false,
      imageUrl: "",
      img: "",
      rules: {
        name: [
          {
            required: true,
            message: this.$t("message.请输入名字"),
            trigger: "blur",
          },
        ],
        tel: [
          {
            required: true,
            message: this.$t("message.请输入有效的电话号码"),
            trigger: "blur",
          },
        ],
        confirmCode: [
          {
            required: true,
            message: this.$t("message.请输入验证码"),
            trigger: "blur",
          },
        ],
        loginID: [
          {
            required: true,
            message: this.$t("message.请输入账号名"),
            trigger: "blur",
          },
          {
            validator: this.loginIDConfirm,
            message: this.$t("message.账号名长度"),
            trigger: "blur",
          },
        ],
        oldpass: [
          {
            required: true,
            message: this.$t("message.请输入旧密码"),
            trigger: "blur",
          },
        ],
        newpass: [
          {
            required: true,
            message: this.$t("message.请输入新密码"),
            trigger: "blur",
          },
        ],
        againpass: [
          {
            required: true,
            message: this.$t("message.请再次输入新密码"),
            trigger: "blur",
          },
          {
            validator: this.loginIDConfirm,
            message: this.$t("message.两次输入的新密码不一致"),
            trigger: "blur",
          },
        ],
      },
      pass: {
        oldpass: "",
        newpass: "",
        againpass: "",
      },
      options: [
        {
          value: 0,
          label: this.$t("message.个人信息"),
        },
        {
          value: 1,
          label: this.$t("message.注册电话"),
        },
        {
          value: 2,
          label: this.$t("message.修改密码"),
        },
      ],
      action: 0,
      defaultimg: "../../../static/images/tbimg.png",
      upimg: "",
    };
  },

  methods: {
    submitFormyes(e) {
      let func = "submitForm" + e;
      let c = "ruleForm" + e;
      this[func](c);
    },
    // 获取用户信息
    getuserinfo() {
      // 登录
      // rejecthttp(true,'get',"/manage/organization/employee/getinfo",{
      rejecthttp(
        true,
        "get",
        "/manage/account/getaccountinfo",
        {},
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            console.log(doc.data);
            this.form.name = doc.data.data.name;
            this.form.workname = doc.data.data.workname;
            this.edituserinfo.name = doc.data.data.workname;
            this.imageUrl = doc.data.data.headimg ? doc.data.data.headimg : "";
            this.upimg = doc.data.data.headimg ? doc.data.data.headimg : "";
            this.form.tel = doc.data.data.mobile;
            this.form.sex = doc.data.data.gender;
          }
        }
      );
    },
    handlechange(e) {
      e = this.edituserinfo.headimg;
      console.log(e);
      let extra = e.split(".")[e.split(".").length - 1];
      extra = extra.toLowerCase();
      if (extra != "png" && extra != "jpg" && extra != "jpeg") {
        this.$message({
          type: "error",
          message: this.$t("message.上传头像图片格式只能为"),
        });
        return;
      }
      let c = document.querySelector(".fileupload");
      console.log(c);
      let d = c.querySelector("input");
      console.log(d);
      let file = d.files[0];
      console.log(d.files);
      let size = file.size;
      if (size / 1024 > 2000) {
        this.$message({
          type: "error",
          message: this.$t("message.图片大小不能超过2mb"),
        });
        return;
      }
      console.log(file);
      var reader = new FileReader();
      this.edituserinfo.headImg = file;
      console.log(this.edituserinfo.headImg);
      var that = this;
      reader.onload = function (e) {
        // target.result 该属性表示目标对象的DataURL
        console.log(e.target.result);
        that.imageUrl = e.target.result;
      };
      // 传入一个参数对象即可得到基于该参数对象的文本内容
      reader.readAsDataURL(file);
    },
    // 获取验证码
    getCode() {
      rejecthttp(
        false,
        "get",
        "/manage/account/getsmscode",
        {
          appid: "188",
          mobile: this.form.tel,
          type: "updateaccountmobile",
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.codeable = true;
            console.log(doc.data);
            this.handleID = doc.data.data;
            var that = this;
            console.log(that.handleID);
            var interval = setInterval(() => {
              that.time--;
            }, 1000);
            setTimeout(() => {
              that.codeable = false;
              that.time = 60;
              clearInterval(interval);
            }, 60000);
          }
        }
      );
    },
    selectedPhone() {
      console.log(this.phone_code);
    },
    resetForm(formName) {
      console.log(formName);
      this.$refs["ruleForm" + formName].resetFields();
      this.getuserinfo();
    },
    submitForm0(formName) {
      let formdata = new FormData();
      let updata = {
        gender: this.form.sex,
        headImg: this.edituserinfo.headImg,
        name: this.form.name,
      };
      for (let k in updata) {
        console.log(k);
        formdata.append(k, updata[k]);
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          rejecthttp(
            true,
            "post",
            "/manage/account/updateaccountinfo",
            formdata,
            this,
            (doc) => {
              changeflagCLOSED(doc, 1, this);
              if (doc.data.Code == "MSGKEY_OK") {
                console.log(doc.data);
              }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitForm1(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          rejecthttp(
            true,
            "get",
            "/manage/account/updateaccountmobile",
            {
              handleid: this.handleID,
              mobile: this.form.tel,
              code: this.form.confirmCode,
            },
            this,
            (doc) => {
              changeflagCLOSED(doc, 1, this);
              if (doc.data.Code == "MSGKEY_OK") {
                console.log(doc.data);
              }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitForm2(formName) {
      let submit = true;
      this.$refs[formName].validate((valid) => {
        console.log(valid);
        if (valid) {
          // alert('submit!');
        } else {
          submit = false;
          console.log("error submit!!");
          return false;
        }
      });
      if (submit) {
        rejecthttp(
          true,
          "post",
          "/manage/account/updateaccountpassword",
          {
            first: this.pass.oldpass,
            second: this.pass.newpass,
          },
          this,
          (doc) => {
            changeflagCLOSED(doc, 1, this);
            if (doc.data.Code == "MSGKEY_OK") {
              console.log(doc.data);
            }
          }
        );
      }
    },
    loginIDConfirm(v, c, callback) {
      if (this.pass.newpass != this.pass.againpass) {
        //显示错误提示
        // this.pass=true
        if (callback) callback(false);
        return false;
      }

      return true;
    },
    select() {
      let sel = document.querySelector(".selectall");
      sel.click();
    },
    goout() {
      this.$emit("goout");
    },
  },

  computed: {},
  created() {},
  mounted() {
    this.getuserinfo();
  },
  destroyed() {},
};
</script>

<style scoped>
.formList {
  margin: auto;
  height: 400px;
  padding: 50px 100px 0 100px;
  /* background-image: url('../../assets/img/logo.a13e.svg'); */
  background-repeat: no-repeat;
  background-position: center;
}
.welcome {
  font-size: 44px;
  margin-bottom: 20px;
}
.centerUser {
  position: absolute;
  width: 100%;
  height: 720px;
  top: 280px;
  left: 50%;
  /* background-color: #F8F8F8; */
  /* border: 1px solid #303133; */
  z-index: 2001;
  transform: translate(-50%, -50%);
}
.el-header,
.el-footer {
  /* color: #333; */
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  line-height: 60px;
}
.el-footer {
  text-align: center;
  /* background-color: #E9EEF3; */
}
.el-footer {
  /* background-color: #d3dce6; */
  border-top: 1px solid rgb(216, 208, 208);
  color: #333;
  text-align: right;
  line-height: 30px;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.el-main {
  position: relative;
  background-color: #e9eef3;
  color: #333;
  height: 76vh;
  overflow: auto;
  font-size: 18px;
  text-align: left;
}
.el-main input {
  height: 60px;
}
.img {
  width: 40px;
}
.selection {
  border: none;
  background-color: #f8f8f8;
  color: blue;
  cursor: pointer;
}
.container {
  width: 40%;
  margin: auto;
  /* background-color: rgb(180, 159, 159); */
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/usercenter.vue